import React, { createRef, Fragment } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import SplitCommon from '../Common/SplitCommon';
import { prepareLabelNameMapper, showToast,formatTime, getSessionValue, syncOperation, isValidData, stopAudio, checkMicrophonePermission, setSessionValue, translateContent, parseJSON, confirmBox, handleErrorResponse,CheckUlrValid,getPermissions, loadWebWidgetData, getCopsPickListItems, getPopupFromDemoAccount, isMobile, checkIsAgencyView } from '../../Common/Appcommon';
import AIAgentsSideBar from './AgentsSideBar';
import { populateFormDetails, getTemplatesFormDetails, loadFormData,getRetelllToken} from '../../Common/Appcommon';
import AgentMainContent from './AgentMainContent';
import {providerConn,getProviderKey,updateBlandAgent,fetchPhNum,generateBlandAgent,getAssistantDetails, updateAgentInfo,fetchvoiceLib} from '../Agents/ProviderDetails';
import "./assets/index.css";
import AgentMainHeader from "./AgentMainHeader";
import requestApi from '../../services/requestApi.service';
import NoRecordFound from '../Common/NoRecordFound';
import aiData from "../../assets/utils/images/agent_no_records.png"
import Select from "react-select";
import call_cancel from "./assets/images/call-cancel.svg";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Popover,Container} from "reactstrap";
import CustomTable from '../../Common/CustomTable';
import { PopupContext } from "./../../Common/WebCallContext";
import Common from '../Common';
import CreateAgentModal from './CreateAgentModal';
import ImportModel from './ImportModel';
import Loading from '../../Common/Loading';
class Agents extends React.Component {
    formname = "table_250";
    voiceFormname  = "table_280";
    subAppid = getSessionValue("subAccountAppid");
    isAllowNewConfig = getSessionValue('isAllowNewAgentConfig') === true || getSessionValue('isAllowNewAgentConfig') === "true" ? true : false;
    static contextType = PopupContext;
    constructor(props) {
        super(props);
        this.childRef = createRef();
        this.state = {
            formData : [],
            formDetails: [],
            templates: [],
            selectedTemplate: [],
            listFields: [],
            page: 1,
            limit: 50,
            rowData: {},
            nameLabelMapper: {},
            sideBarLoader : false,
            mainLoader : false,
            currentagentindex: 0,
            isNoDataFound : false,
            assistantId : "",
            popoverOpen: false,
            isCallReady: false,
            callStartTime:"",
            cDur :"",
            showLoading : false,
            providerCon :{},
            providerName : "",
            blandCon : "",
            agentname:"",
            isModalOpen: false, 
            voice_data : [],
            voice_column : [],
            selectedRow : [],
            defAccentDrop : {},
            accentDropList :{},
            defGenderDrop :{},
            genderDropList : {},
            defAgeDrop : {},
            ageDropList : {},
            accentFilter : "",
            ageFilter : "",
            genderFilter : "",
            selectVoiceRow : "",
            isAgentLoading :false,
            audioStates : {},
            isRefresh : false,
            knowledgeBase:[],
            isMinimized : false,
            agentList : {},
            newAgentModalOpen : false,
            curRowId : null,
            showAgentOptionLoading : false,
            agentVoiceId : [],
            selectedVoice:"",
            postWebhooksEnabled:true,
            transcript :[],
            allowCreateAgents :true,
            allowDuplicateAgents : true,
            allowDeleteAgents:true,
            allowPublishAgents:true,
            showAgentProfileSettings : true,
            showAgentRoleSettings :true,
            showAgentActionSettings:true,
            showAgentKnowledgeBase:true,
            showAgentDeploy:true,
            showButtonLoading:false,
            isImportModal:false,
            isSubAccountView : getSessionValue("isSubAccountView"),
            voiceIconId : "",
            widgetList: [],
            isToggle : false,
            isVoiceLoading: true,
            isMobileView: isMobile(),
            isAgentConfigView: false,
        }
    }

    componentDidMount = async () => {
        let proName = getSessionValue("agent_provider_name");
        let proCon = "";
        //let apiKey = getProviderKey("retell");
        //let res = await fetchvoiceLib(apiKey);
        if(proName !== "bland"){
            proCon = await providerConn(proName);
        }
        
        this.setState({
            sideBarLoader: true,
            mainLoader : true,
            providerCon: proCon,
            providerName :proName,
        });
        await this.fetchVoiceList();
        await syncOperation("START_AGENT_SYNC");
        await this.fetchFormDetails();
        await this.fetchAIAgents();
        await this.loadKnowledgeBaseList();
        
        this.setState({
            sideBarLoader: false,
            mainLoader : false,
        });
        let blandCon = this.state.blandCon;
        if(proName.toLowerCase() === "vapi" && proCon !== ""){
            proCon.on('error', (e) => {
                clearInterval(this.state.intervalId);
                proCon.stop();
                this.setState({
                    showLoading : false,
                });
                this.setCallEndProcess();
                let error = e.error !== undefined && e.error !== null ? (e.error.blockedMedia !== undefined && e.error.blockedMedia !== null ? e.error.blockedMedia[0] + " " +e.error?.msg?.toLowerCase(): e.error?.msg?.toLowerCase()) : "Unable to talk right now.";

                showToast("ERROR! "+error,'top-right','error');
            })

            proCon.on("call-end", () => {
                if(this.state.isCallReady){
                    this.setCallEndProcess();
                }
            });
            proCon.on("call-start", () => {
                this.callStartProcess();
            });

            proCon.on("message", (msg) => {
                if (msg.type !== "transcript") return;
                let { transcript } = this.state;
                let role = msg.role === "assistant" ? "agent" : msg.role === "user" ? "user" : msg.role;
                let message = msg.transcript;
                let isFinal = msg.transcriptType === "final";
                let updatedTranscript = [...transcript];
                const lastIndex = updatedTranscript.length - 1;
                if (
                    updatedTranscript[lastIndex] &&
                    updatedTranscript[lastIndex].role === role &&
                    !updatedTranscript[lastIndex].isFinal
                ) {
                    updatedTranscript[lastIndex] = { role, content: message, isFinal };
                } else {
                    updatedTranscript.push({ role, content: message, isFinal });
                }
                this.setState(prev => ({
                    transcript: updatedTranscript,
                }));
            
                if (!isFinal) this.handelTranscriber();
            });
        }else if(proName.toLowerCase() === "retell" && proCon !== ""){
            proCon.on("error", (error) => {
                clearInterval(this.state.intervalId);
                this.setState({
                    showLoading : false,
                });
                showToast("ERROR! " +error,'top-right','error');
                proCon.stopCall();
                this.setCallEndProcess(false);
            });

            proCon.on("call_started", () => {
                this.callStartProcess();
              });

            proCon.on("call_ended", () => {
                this.setCallEndProcess();
            });

            proCon.on("update", (msg) => {
                this.setState({
                    transcript: msg.transcript
                });
                this.handelTranscriber();
            });

        }else if(proName.toLowerCase() === "bland" && blandCon !== ""){
            blandCon.on('conversationStarted', (e) => {
            });
            
            blandCon.on('speaking', () => {
            });
        
            blandCon.on('conversationEnded', () => {
                this.setCallEndProcess();
            });

            blandCon.on('error', (e) => {
                let error = e.error !== undefined && e.error !== null ? (e.error.blockedMedia !== undefined && e.error.blockedMedia !== null ? e.error.blockedMedia[0] + " " +e.error?.msg?.toLowerCase(): e.error?.message?.toLowerCase()) : "Unable to talk right now.";
                showToast(translateContent("vm.agents.convo.error"),'top-right','error');
                this.setState({
                    showLoading : false,
                });
                this.setCallEndProcess(false);
                console.error('An error occurred during the conversation:', error);
            });

        }
    };
   
    fetchFormDetails = async () => {
        let formDetail = await populateFormDetails(this.formname);
        let { templates, selectedTemplate } = await getTemplatesFormDetails(formDetail);
        this.setState({
            formDetails: formDetail,
            templates, 
            selectedTemplate
        })
    };

    fetchAIAgents = async () => {
        let { formDetails,selectedTemplate,providerName,curRowId } = this.state;
        selectedTemplate[0] = '312';
        let adFilterSearch = "";
        if(providerName !== "" && providerName !== null ){
            adFilterSearch = "nondate@table_250@Provider@is@"+providerName+"@AND#";
        }
        let agentData = await loadFormData(this.formname, formDetails, selectedTemplate,"",adFilterSearch);
        if (agentData.issuccess) {
            let { formData, listFields } = agentData;
            let nameLabelMapper = await prepareLabelNameMapper(formDetails[1]);
            let rowData = formData && Array.isArray(formData) && formData.length > 0 
            ? formData.find(row => row.table_250_id === curRowId) || formData[0] 
            : {};
            let selectedVoice = rowData?.voice_id !== undefined ? rowData.voice_id : "";
            let permissionRes = await getPermissions();
            if(permissionRes.issuccess){
                if (permissionRes.data && permissionRes?.data && permissionRes.data !== null) {
                    const data = parseJSON(permissionRes.data);
                    const safeSet = (key, stateKey) => {
                        if (data?.[key] !== undefined && data[key] !== null && data[key] !== "") {
                            this.setState({ [stateKey]: data[key] });
                        }
                    };
                    safeSet("post_webhooks_allowed", "postWebhooksEnabled");
                    safeSet("allowCreateAgents", "allowCreateAgents");
                    safeSet("allowDuplicateAgents", "allowDuplicateAgents");
                    safeSet("allowDeleteAgents", "allowDeleteAgents");
                    safeSet("showAgentProfileSettings", "showAgentProfileSettings");
                    safeSet("showAgentRoleSettings","showAgentRoleSettings");
                    safeSet("showAgentActionSettings","showAgentActionSettings")
                    safeSet("showAgentKnowledgeBase","showAgentKnowledgeBase");
                    safeSet("showAgentDeploy","showAgentDeploy");
                    safeSet("allowPublishAgents","allowPublishAgents");
                }
            }
            this.setState({
                formData, listFields, nameLabelMapper, rowData, isNoDataFound: Object.keys(rowData).length === 0,selectedVoice
            })
        }
        this.setState({
            mainLoader : false,
        })
    }

    onAgentChange = (agent, index) => {
        let selectedVoice = agent?.voice_id !== undefined ? agent.voice_id : "";
        this.setState({
            rowData : agent,
            currentagentindex: index,
            selectedVoice: selectedVoice,
            isAgentConfigView: !this.state.isAgentConfigView
        })
    }

    resetToAgentDetail = (agent) => {
        this.setState({
            rowData : agent,
        })
    }

    getSideBarTitleContent = (agentcount = 0) => {
        return(
            <>
                <span>Agents<span class="count">{agentcount}</span></span>
            </>
        )
    }

    handleDropDownChange = (value,option) => {
        if(value === "webcall"){
            if (getPopupFromDemoAccount()) {
                return;
            }
            const { rowData, nameLabelMapper } = this.state;
            const { setIsCallReady, setPopoverOpen, setAgentname } = this.context; // Access context setters
            setAgentname(rowData[nameLabelMapper['Agent_Name']]);
            setPopoverOpen(true);
            setIsCallReady(true); 
            this.startCall();
        }else{
            showToast("Coming Soon!");
        }
    };

    togglePopover = () => {
        this.setState(prevState => ({
            popoverOpen: !prevState.popoverOpen ? true : true
        }));
    };


    callStartProcess = () => {
        const {setCurDuaration} = this.context
        let startTime = new Date();
        this.setState({ 
            isCallReady: true, 
            callStartTime: startTime, 
            cDur: "0:00",
            showLoading: false,
        }, async () => {
            // this.togglePopover();
        });
        // this.handlePopOver();
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
        
        let intervalId = setInterval(() => {
            let currentTime = new Date();
            let duration = Math.floor((currentTime - startTime) / 1000);
            let formattedDuration = formatTime(duration);
            this.setState({ cDur: formattedDuration });
            setCurDuaration(formattedDuration); // Initialize call duration
        }, 1000);

        this.setState({ intervalId });
    }

    startCall = async () => {
        const { setIsCallReady, setPopoverOpen } = this.context;
        if(await checkMicrophonePermission()){
            this.setState({ showLoading: true });
            try{
                let {providerCon,providerName} = this.state;
                if(providerName !== "bland" && providerCon === ""){
                    showToast(translateContent("vm.agents.call.error"),'top-right','error');
                    return;
                }else if (this.state.isCallReady) {
                    showToast(translateContent("vm.agents.oncall.error"));
                    this.setState({showLoading:false});
                    return; 
                }
                let {rowData,nameLabelMapper} = this.state;
                let agentId = rowData[nameLabelMapper['Agent_ID']];
                this.setState({
                    agentname:rowData[nameLabelMapper['Agent_Name']],
                    voiceIconId : rowData[nameLabelMapper['voice_id']],
                });
                if(providerName === "vapi"){
                    let pubKey = getProviderKey(this.state.providerName);
                    let agentDetails = await getAssistantDetails(pubKey,agentId,this.state.providerName);
                    if(agentDetails !== null){
                        this.initiateVapiCall(providerCon,agentId);
                        this.togglePopover();
                        this.setState({ 
                            isCallReady: true,
                        });
                        this.handlePopOver();
                    }else {
                        this.setState({ showLoading: false });
                    }
                }else if(providerName === "bland"){
                    let agId = rowData[this.formname + "_id"];
                    let apiKey = getProviderKey(this.state.providerName);
                    let num = await fetchPhNum(agId,this.formname);
                    if(typeof agentId !== "undefined" && agentId !== null && agentId !== ""){
                        agentId = await updateBlandAgent(apiKey,agentId,num,rowData,nameLabelMapper);
                    }else{
                        agentId = await generateBlandAgent(agId,apiKey,num,rowData,nameLabelMapper);
                    }
                
                    let proCon = await providerConn(providerName,agentId);
                    this.setState({
                        blandCon: proCon,
                    });
                    
                    if(proCon !== ""){
                        this.initiateBlandCall(proCon);
                        this.setState({ 
                            isCallReady: true,
                        });
                        this.handlePopOver();
                    }else {
                        this.setState({ showLoading: false });
                        showToast(translateContent("vm.agents.connection.error"), 'top-right', 'error');
                    }
                }else if(providerName = "retell"){
                    let apiKey = getProviderKey(this.state.providerName);
                    let agentDetails = await getAssistantDetails(apiKey,agentId,this.state.providerName);
                    if(agentDetails != null){
                        this.initiateRetailsAiCall(providerCon,agentId);
                        this.setState({ 
                            isCallReady: true,
                        });
                        this.handlePopOver();
                    }else {
                        setPopoverOpen(false);
                        setIsCallReady(false);
                        this.setState({ showLoading: false });
                    }
                }
            }catch(error){
                this.setState({ showLoading: false });
            }
        }else{
            this.setCallEndProcess(false);
            showToast(translateContent("vm.agents.permission.error"), 'top-right', 'error');
        }
       
    };


    initiateVapiCall = (proCon,agentId) =>{
        try{
            proCon.start(agentId);
            this.setState({
                showLoading: true,
            });
        }catch(error){
            this.setState(prevState => ({
                showLoading: false
            }));
            console.error("Error during Vapi call:", error.message || error);
        }
    } 

    initiateRetailsAiCall = async (proCon, agentId) => {
        try {
            let apiKey = getProviderKey(this.state.providerName);
            let res = await getRetelllToken(apiKey, agentId);
            if (res.issuccess) {
                let retailsDetails = res.data;
                let retellToken = retailsDetails['access_token'];
                this.retryWithBackoff(() => proCon.startCall({ accessToken: retellToken }));
            } else {
                this.setState({ showLoading: false });
                showToast(translateContent("vm.agents.token.error"), 'top-right', 'error');
                this.setCallEndProcess(false);
            }
        } catch (error) {
            this.setState({ showLoading: false });
            console.error("Error during Retail AI call:", error.message || error);
        }
    }
    
    initiateBlandCall = (proCon) => {
        proCon.initConversation({
            sampleRate: 44100
        })
        .then(() => {
            this.callStartProcess();
        })
        .catch((error) => {
            console.error('Error initiating call:', error);
        });
    } 

    stopCall = () => {
        let {providerCon,providerName,blandCon} = this.state;
        if(providerName === "vapi"){
            providerCon.stop();
        }else if(providerName === "bland"){
            blandCon.stopConversation();
            this.setCallEndProcess();
        }else if(providerName === "retell"){
            providerCon.stopCall();
        }
    };

    setCallEndProcess = (showToastMessage = true) => {
        clearInterval(this.state.intervalId);
        this.setState(
            { 
                isCallReady: false, 
                callStartTime: "", 
                cDur: "0:00",
                showLoading: false,
            }, async () => {
                this.togglePopover();
            }
        );
        this.handlePopOver(false);
        if(showToastMessage){
            showToast("The call has ended.");
        }
        this.setState({ transcript : [] });
    }

    uploadVoice = async (data) =>{
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "SAVE_VOICE_LIST",
            FORMINPUT: data,
            Provider : "retell",
            isOtherApiReq: true
        };
        return;
        try {
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
            }
        } catch (error) {
            console.error("Error fetching plan pricing:", error);
        }
    }

    fetchVoiceList = async (filter = "") => {
        const { providerName } = this.state;
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_VOICE_PROVIDER",
            PROVIDER: providerName,
            FILTER: filter,
            isOtherApiReq: true
        };
    
        try {
            const response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                const data = response.data;
                if(data.length > 0){
                    const column = await this.constructVoiceData(data);
                    const [transformedVoiceData, accentDropList, genderDropList, ageDropList] = [
                        data[0].map((item) => ({
                            ...item,
                            Icons: '',
                        })),
                        this.createDropDownList(data[0], 'Accent'),
                        this.createDropDownList(data[0], 'Gender'),
                        this.createDropDownList(data[0], 'Age')
                    ];
                    const stateUpdates = {
                        voice_data: transformedVoiceData,
                        voice_column: column,
                    };
        
                    if (!filter) {
                        Object.assign(stateUpdates, {
                            defAccentDrop: accentDropList[0],
                            defGenderDrop: genderDropList[0],
                            defAgeDrop: ageDropList[0],
                            accentDropList,
                            genderDropList,
                            ageDropList,
                        });
                    }
        
                    this.setState(stateUpdates);
                }else {
                    this.setState({
                        voice_data: [],
                    });
                }
                
            }
        } catch (error) {
            console.error("Error fetching voice list:", error);
        }
        this.setState({
            isRefresh : true,
            selectVoiceRow : "",
            isVoiceLoading : false,
        });
    };
    
   
    constructVoiceData = async (data) => {  
        const voice_column = [];
        const fields = data[1][0];  
        const aliases = data[1][1]; 
        voice_column.push({name: "", alias: "Icon"});
        fields.forEach((field, index) => {
            voice_column.push({
                name: field, 
                alias: aliases[index],
            });
        });
        voice_column.push({name: "", alias: "Url"});
        return voice_column; 
    };
    
    submitForm = async (data, type = "") => {
        console.log(getPopupFromDemoAccount())
        if (getPopupFromDemoAccount()) {
            return;
        }
        let {nameLabelMapper, formData, currentagentindex,providerName,voice_data,isAgentLoading} = this.state;
        let isNameEmpty = (data) => !data?.["Agent Name"]?.trim();
        if (isNameEmpty(data)) {
            showToast(translateContent("vm.agents.name.requird"),"top-right", "error");
            return;
        }
        let details = data[nameLabelMapper['advanced_settings']]?.trim();
        if(details !== ""  && details !== null && details !== undefined ){
            let serverdetails = JSON.parse(details);
            let server_url = serverdetails['server_url']?.trim();
            if(server_url !== "" && server_url !== null && server_url !== undefined){
                let server_url = serverdetails['server_url']?.trim();
                if (!CheckUlrValid(server_url)) {
                    showToast(translateContent("vm.agents.advsetting.url"),"top-right", "error");
                    return;
                }
            }
        }
        if(data["voice_id"] == "" || data["voice_id"] == undefined){
            showToast(translateContent("vm.agents.voice.requird"),"top-right", "error");
            return;
        }
        if (
            !data[nameLabelMapper['Call_Start_Message']] || 
            !data[nameLabelMapper['System_Prompt']]
        ) {
            if (!data[nameLabelMapper['Call_Start_Message']]) {
                showToast(translateContent("vm.agent.startmsg.error"), "top-right", "error");
            }
            
            if (!data[nameLabelMapper['System_Prompt']]) {
                showToast(translateContent("vm.agent.systemprompt.error"), "top-right", "error");
            }
        
            return;
        }

        this.setState({
            mainLoader : true,
        });
        if (data['phoneNumberDetails']) {
            let paramsData = {
                provider: providerName,
                phoneNumberDetails : data['phoneNumberDetails'],
                agentTableId:data['table_250_id'],
                agentId:data[nameLabelMapper['Agent_ID']],
            }
            const params = {
                ENTITY: "AIPROCESSOR",
                OPERATION: "UPDATE_IO_PHONE_DETAILS",
                FORMDATA: paramsData,
            };
            try {
                const response = await requestApi.processServerRequest(params);
                if (!response.issuccess) {
                    console.error("API response error:", response);
                }
            } catch (error) {
                console.error("Error while updating phone number details:", error);
            }
        }
        if (data['webWidgetsDetails']) {
            const params = {
                ENTITY: "AIPROCESSOR",
                OPERATION: "UPDATE_WEB_WIDGET",
                DATA: data['webWidgetsDetails'],
                agentId:data["table_250_id"],
            };
            try {
                const response = await requestApi.processServerRequest(params);
                if (!response.issuccess) {
                    console.error("API response error:", response);
                }
            } catch (error) {
                console.error("Error while updating phone number details:", error);
            }
        }
        let apiKey = getProviderKey(providerName);
        if(data.knowledgebase && typeof(data.knowledgebase) === "string"){
            data.knowledgebase = parseJSON(data.knowledgebase);
        }
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "SAVE_AGENT_DETAILS",
            FORMINPUT: data,
            nameLabelMapper: nameLabelMapper,
            PROVIDER : providerName,
            SUBACCOUNTID : this.subAppid,
            isProviderUpdate : this.isAllowNewConfig && type !== "adv_set",
            isOtherApiReq: true,
        };
        try {
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                formData[currentagentindex] = data;
                await this.fetchAIAgents();
                this.refreshAgents();
                this.setState({
                    rowData: data,
                    formData: formData,
                    mainLoader : false,
                })
                showToast(translateContent("vm.update.success"))
                return true;
            }else {
                showToast(response.errormsg,"top-right", "error");
            }
        } catch (error) {
            showToast(translateContent("vm.agents.update.failed"))
            console.error("Error fetching plan pricing:", error);
        }
        // }else {
        //     showToast("Error! Agent Details Updated Failed.")
        // }
        this.setState({
            mainLoader : false,
        });
        return false;
    }

    handleRowChange = (name, value, isSubField = false) => {
        this.setState(prevState => {
            let updatedRowData = { ...prevState.rowData };
                if (isSubField) {
                    const [parentField, childField] = name.split(",");
                    let parentValue = updatedRowData[parentField];
                    let parsedParent = {};
                    try {
                        parsedParent = typeof parentValue === "string" 
                            ? JSON.parse(parentValue)
                            : (parentValue || {});
                    } catch (e) {
                        console.error("Invalid JSON in", parentField, e);
                    }
                    parsedParent[childField] = value;
                    updatedRowData[parentField] = JSON.stringify(parsedParent);
                } else {
                    updatedRowData[name] = value;
                }
            return {
                rowData: updatedRowData
            };
        });
    };

    getTitleContent = () => {
        return(
            <>
                <div className='d-flex'>
                    <div>
                        <span>Agents</span>
                    </div>
                    
                </div>
            </>
        )
    }
    getBodyContent = () => {
        const isAgencyView = checkIsAgencyView();
        return(
            <div className='d-flex'>
                {this.state.isSubAccountView && isAgencyView && (
                    <div className='me-3'>
                        {this.getButtonFromImport(undefined,false)}
                    </div>
                )}
                {((this.isAllowNewConfig && this.state.allowCreateAgents) || isAgencyView) && (
                    <div className='app-header-right'>
                        <div>
                            <Button onClick={(e) => this.handleCreateAgentModal()} className="mb-2 cursor-pointer btn btn-secondary theme-bg-g" type="submit">
                                <span className="agent-create-btn-spn-1">
                                    <i class="fi fi-br-plus"></i>Add Agent
                                </span>
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        )
    }
    
    handleModal = async (voiceId = "") =>{
        if(!this.state.isModalOpen){
            await this.fetchVoiceList();
        }else{
            let {audioStates} = this.state;
            stopAudio(audioStates)
        }
        if(!this.state.isToggle && !this.state.voice_data.length > 0){
            showToast(translateContent("vm.agents.no.voices"),'top-right', 'error');
            this.setState({
                isToggle : false
            });
            return;
        }
        this.setState(prevState => ({
            isModalOpen: !prevState.isModalOpen,
            selectVoiceRow : "",
        }));
        if(voiceId !== ""){
            this.setState({
                agentVoiceId : voiceId,
            });
        }
        this.setState({
            isToggle : false
        });
    };

    toggle = () =>{
        this.setState({
            isToggle : true,
        }, async () => {
            this.handleModal()
        });
    };

    setFilterValue = async (filed, data) => {
        let val = data.value;
        if(val == "All"){
            val = "";
        }
        this.setState({
            filed : val,
        });
    };

    onTemplateChange = async (data) => {
        if(await isValidData(data)){
            this.setState({
                isVoiceLoading : true,
            });
            let val = data.value;
            const filters = {
                "Accent": "accentFilter",
                "Gender": "genderFilter",
                "Age": "ageFilter",
            };

            const dropDown = {
                "Accent": "defAccentDrop",
                "Gender": "defGenderDrop",
                "Age": "defAgeDrop",
            };
            if (val === "All") {
                val = "";
            }
            const filterKey = filters[data.name];
            const dropDownKey = dropDown[data.name];
            if (filterKey) {
                this.setState({ [filterKey]: val }, async () => {
                });
            }

            if (dropDownKey) {
                this.setState({ [dropDownKey]: data }, async () => {
                    await this.fetchFilVoice();
                });
            }
        }else{
            
        }        
    }

    fetchFilVoice = async () => {
        const { accentFilter, ageFilter, genderFilter } = this.state;
        const conditions = [
            accentFilter && `Accent = '${accentFilter}'`,
            ageFilter && `Age = '${ageFilter}'`,
            genderFilter && `Gender = '${genderFilter}'`
        ].filter(Boolean);
    
        const cond = conditions.join(" and ");
        await this.fetchVoiceList(cond);
    };

    createDropDownList = (data, key) => {
        const uniqueValues = Array.from(new Set(data.map(item => item[key])));
        const dropDownList = [{ value: "All", label: 'All' ,name : key}];
        uniqueValues.forEach(value => {
            dropDownList.push({ value, label: value,name : key });
        });
        return dropDownList;
    };

    onLoadselectVoiceRow = (row) =>{
        this.setState({
            selectVoiceRow : row,
            isRefresh : false,
        });
    }
    
    selectVoiceRow = (row) => {
        this.setState({
            selectVoiceRow : row,
            isRefresh : false,
        },() =>{
            this.saveSelectVoice();
        });
    }

    saveSelectVoice = () => {
        let { rowData, nameLabelMapper, selectVoiceRow,voice_data } = this.state;
        if(selectVoiceRow === "" && voice_data.length > 0){
            showToast(translateContent("vm.agents.select.voice"));
            return;
        }
        let voiceId = selectVoiceRow['Voice_Id'];
        //        let voiceId = selectVoiceRow[`${this.voiceFormname}_id`];
        // const updatedRowData = { ...rowData, [nameLabelMapper['voice_id']]: voiceId };
        this.setState({
            selectedVoice: voiceId,
        });
        this.handleModal();
    }

    handlePopOver = (isCall = true) =>{
        const { setIsCallReady, setCurDuaration,setPopoverOpen,setAgentname,setStopCall,setToggleFun,setTranscript,setShowLoading,setShowTranscript,setVoiceicon} = this.context; // Access context setters
        setPopoverOpen(isCall);
        setIsCallReady(isCall); 
        setShowLoading(isCall);
        setAgentname(this.state.agentname);
        setVoiceicon(this.state.voiceIconId);
        setToggleFun(() => this.togglePopover);
        setStopCall(() => this.stopCall);
        setCurDuaration("Connecting"); // Initialize call duration
        setTranscript([]); // Initialize transcript
        setShowTranscript(true)
    }

    handelTranscriber = async (data) => {
        const { transcript, setTranscript } = this.context;
        setTranscript(this.state.transcript);
    }   
    retryWithBackoff = async (fn, retries = 3, delay = 1000) => {
        for (let i = 0; i < retries; i++) {
            try {
                return await fn();
            } catch (err) {
                if (i === retries - 1) throw err;
                console.warn(`Retrying in ${delay}ms...`);
                await new Promise(res => setTimeout(res, delay));
                delay *= 2; // Exponential backoff
            }
        }
    };

    loadKnowledgeBaseList = async () => {
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "LOAD_KNB",
        }
        let response = await  requestApi.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            let Option = [];
            let status = '';
            if(data.length > 0) {
                data.map((item, index) => { 
                    if(this.state.providerName === 'retell'){
                        let details = parseJSON(item['details']);
                        status = details['status'];
                    }
                    if(this.state.providerName === 'vapi' || (this.state.providerName === 'retell' && status === 'complete')){
                        Option.push({value: item['id'], label: item['name'] });
                    }
                });
                this.setState({ knowledgeBase: Option || [] });
            }
        }
    }
      
    handleCreateAgentModal = () =>{
        let apiDetails = getSessionValue("agent_api_details");
        if(apiDetails == "" || apiDetails == null || apiDetails == undefined ||  apiDetails == "null"){
            handleErrorResponse(translateContent("vm.agent.provider.empty"));
            return;
        }
        this.setState(prevState => ({
            newAgentModalOpen: !prevState.newAgentModalOpen
        }));
    }

    saveAgentInfo = async (data,isblank = false) => {
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "CREATE_AGENT_DETAILS",
            FORMINPUT: data,
            PROVIDER : this.state.providerName,
            SUBACCOUNTID : this.subAppid,
            isOtherApiReq: true,
            ISBLANK : isblank,
        };
        try {
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                await this.fetchAIAgents();
                this.setState({
                    curRowId: data[0],
                })
                showToast(translateContent("vm.agents.create.succuss"))
            }else {
                showToast(translateContent("vm.agents.create.failed",{errorMsg: response.errormsg}),"top-right", "error")
            }
        } catch (error) {
            console.error("Error fetching plan pricing:", error);
        }finally{
            this.handleCreateAgentModal();
        }
    }

    openCreateAgentModal = (rowData) =>{
        const { voice_data, newAgentModalOpen, providerName } = this.state;
        return (
            <CreateAgentModal 
                isOpen = {newAgentModalOpen}
                handleSave = {this.saveAgentInfo}
                handleToggle = {this.handleCreateAgentModal}
                blankData = {""}
                providerName = {providerName}
                voice_data={voice_data}
            /> 
        );
    }

    handleAgentOptionChange = (name,value) => {
        this.setState({
            mainLoader : true,
        })
        let {rowData,nameLabelMapper,providerName} = this.state;
        let agentId = rowData[nameLabelMapper['Agent_ID']];
        let formid = rowData["table_250_id"];
        if(value === "delete"){
            this.handleDeleteAgent(agentId, providerName);
        }else if(value === "clone"){
            this.handleCloneAgent(agentId, providerName);
        }else if(value === "Post_Call_Event"){
            this.setState({
                mainLoader : false,
            })
            window.open(`#/webhook_logs/agent/${formid}`, "_blank");
        }
        /* this.setState({
            mainLoader : false,
        }) */
    }

    handleDeleteAgent = async (agentId,provider) =>{
        let {rowData,nameLabelMapper} = this.state;
        let agentName = rowData[nameLabelMapper['Agent_Name']];
        let confirm = await confirmBox("Are you sure want to Delete " + agentName + " Agent ?", '', 'warning', 'Delete', 'Cancel');
        if (!confirm) {
            this.setState({
                mainLoader : false,
            })
            return;
        }
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "DELETE_AGENT_INFO",
            AGENT_ID : agentId,
            PROVIDER : provider,
            isOtherApiReq: true
        };
        try {
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                showToast(translateContent("vm.agent.delete.success"));
                await this.fetchAIAgents();
            }
        } catch (error) {
            console.error("Error fetching plan pricing:", error);
        }
        this.setState({
            mainLoader : false,
        })
    }

    handleCloneAgent = async (agentId,provider) =>{
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "CLONE_AGENT_INFO",
            AGENT_ID : agentId,
            PROVIDER : provider,
            isOtherApiReq: true
        };
        try {
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                await this.fetchAIAgents();
                showToast(translateContent("vm.agents.clone.succuss"))
            }else {
                showToast(translateContent("vm.agents.clone.failed",{cloneFailedError: response.errormsg}),"top-right", "error")
            }
        } catch (error) {
            console.error("Error agent Clone:", error);
        }
        /* this.setState({
            mainLoader : false,
        }) */
    }

    getModalContent = () => {
        const {
            isModalOpen,
            voice_data,
            voice_column,
            accentDropList,
            defAccentDrop,
            genderDropList,
            defGenderDrop,
            ageDropList,
            defAgeDrop,
            isRefresh,
            agentVoiceId
        } = this.state;
        const dropdowns = [
            { name: "Accent", list: accentDropList, default: defAccentDrop },
            { name: "Gender", list: genderDropList, default: defGenderDrop },
            { name: "Age", list: ageDropList, default: defAgeDrop }
        ];
        return (
            <Modal isOpen={isModalOpen} contentClassName="voice-model-wid">
                <ModalHeader toggle={this.toggle}>
                    <span>Voice</span>
                    <span className='vm-voice-cnt'>{voice_data.length}</span>
                </ModalHeader>
                <ModalBody className="voice-modal-bdy">
                    <div className="d-flex-alone voice-drop">
                        {dropdowns.map(({ name, list, default: defaultVal }) => (
                            <div key={name} className="voice-drop-wid">
                                <Select
                                    placeholder={`---Choose ${name}---`}
                                    name={`${name.toLowerCase()}-fill`}
                                    className="basic-select"
                                    classNamePrefix="sub-select wa-select"
                                    value={defaultVal || null} // Fallback to null if no default value
                                    onChange={this.onTemplateChange}
                                    options={list && Object.keys(list).length ? list : []} // Fallback to empty array if list is empty
                                    isDisabled={!list || !Object.keys(list).length} // Disable if list is empty
                                    getOptionLabel={({ label }) => label}
                                    formatOptionLabel={({ value, label }, { context }) =>
                                        context === "value" ? (
                                            <div>{`${name} : ${label}`}</div> // Show "Accent: All" only for the selected value
                                        ) : (
                                            <div>{label}</div> // Show just the label in the dropdown list
                                        )
                                    }
                                />
                            </div>
                        ))}
                    </div>
                    <Loading
                        showLoader={this.state.isVoiceLoading}
                        mainContent={
                            <CustomTable
                                agentVoiceId = {agentVoiceId}
                                data={voice_data}
                                columns={voice_column}
                                isSelect={true}
                                selectRow = {this.selectVoiceRow}
                                onLoadselectVoiceRow = {this.onLoadselectVoiceRow}
                                handleAudio = {this.setAudioStates}
                                isRefresh = {isRefresh}
                            />
                        }
                    />
                </ModalBody>
                <ModalFooter className ={"custom-modal-footer"}>
                    <Button
                        className="btn btn-secondary theme-bg-g hide"
                        onClick={(e) => this.saveSelectVoice()}
                    >
                        Select Voice
                    </Button>
                </ModalFooter>
            </Modal>
        );
    };

    setAudioStates = (audio) => {
        this.setState({
            audioStates :audio,
        });
    } 

    refreshAgents = async () => {
        await this.fetchAIAgents();
    }

    onHideSubMenu = () => {
        this.setState({
            isMinimized: !this.state.isMinimized,
            isImportModal: false,
        });
    }

    toggleImportModal = (isRefresh = false) => {
        this.setState(prevState => ({
            isImportModal: !prevState.isImportModal,
        }));
        if(isRefresh === true){
            this.refreshAgents();
        }
    }
    showImportButtomLoading = (state) =>{
        this.setState({ showButtonLoading: state });
    }
    getButtonFromImport = (loading = undefined, sidebar = true)  => {
        let showLoader = loading === undefined ? this.state.showButtonLoading : loading;
        return (
            <Loading
                showLoader={showLoader}
                mainContent={
                    <Button
                        onClick={this.toggleImportModal}
                        className={`mb-2 cursor-pointer ${sidebar ? "agent-create-btn agent-list agent-import-btn": "custom-btn-1"}`}
                        type="button"
                    >
                        <span className="agent-create-btn-spn-1 justify-center">
                            <i className="fi fi-br-plus"></i> Import Agents
                        </span>
                    </Button>
                }
            />
        );
    };

    getImportModel = () =>{
        let { isImportModal } = this.state;
        return(
            <ImportModel type={"agent"} title={"Import Agents"} isModelOpen={isImportModal} toggleModal={this.toggleImportModal} showButtonLoader={this.showImportButtomLoading}/>
        )
    }

    handlePublish = () => {
        if (this.childRef.current && this.childRef.current.triggerSubmit ) {
            this.childRef.current.triggerSubmit();
        }
    };   

    getBackListView = () => {
        this.setState({
            isAgentConfigView: false
        })
    };
    
    render() {
        let {
            formData, 
            rowData, 
            sideBarLoader, 
            mainLoader, 
            nameLabelMapper, 
            isNoDataFound,
            cDur,
            popoverOpen,
            isCallReady,
            showLoading,
            isModalOpen,
            voice_data,
            isAgentLoading,
            knowledgeBase,
            isMinimized,
            newAgentModalOpen,
            providerName,selectedVoice,
            showAgentProfileSettings,
            showAgentOptionLoading,
            allowCreateAgents,
            allowDeleteAgents,
            allowDuplicateAgents,
            showAgentRoleSettings,
            showAgentActionSettings,
            showAgentKnowledgeBase,
            isImportModal,
            showButtonLoading,
            widgetList,
            showAgentDeploy,
            allowPublishAgents,
            isMobileView,
            isAgentConfigView
        } = this.state;
        let agentcount = formData && formData.length ? formData.length : 0;
        if(isNoDataFound && Object.keys(rowData).length == 0){
            return (
                <>
                    <NoRecordFound 
                        title="AI Agents"
                        titleContent={this.getTitleContent()}
                        titleBody = {this.getBodyContent()}
                        img={aiData}
                        content={"No AI Agent Found"}
                    />
                    {newAgentModalOpen &&  this.openCreateAgentModal()}
                    {isImportModal && this.getImportModel()}
                </>
                
            )
        }

        if(isMobileView){
            if(isAgentConfigView){
                return (
                    <Fragment>
                        <Common
                            title="AI Agents"
                            mainLoader={mainLoader}
                            titleKey={"assistant_allowed"}  
                            titleContent={"Update"} 
                            titleBody={
                                <div className="align-content-center">
                                    <a className='cursor-pointer me-auto' onClick={(e) => { this.getBackListView() }}>
                                        <span className='d-flex'>
                                            <i class="fi fi-br-arrow-left pr-1"></i>
                                            <span>Back</span>
                                        </span>
                                    </a>
                                </div>
                            }
                            mainContent={
                                <Container>
                                        {
                                            Object.keys(rowData).length > 0 &&
                                            <>
                                                <div className='mobile-agent-header'>
                                                    <AgentMainHeader
                                                        rowData={rowData}
                                                        isMinimized={isMinimized}
                                                        onHideSubMenu={this.onHideSubMenu}
                                                        fieldNames={nameLabelMapper}
                                                        handleDropDownChange={this.handleDropDownChange}
                                                        handleAgentOptionChange = {this.handleAgentOptionChange}
                                                        isLoading = {mainLoader}
                                                        showAgentLoading = {showAgentOptionLoading}
                                                        allowDuplicateAgents = {allowDuplicateAgents}
                                                        allowDeleteAgents = {allowDeleteAgents}
                                                        allowPublishAgents={allowPublishAgents}
                                                        onPublish={this.handlePublish}
                                                        voiceList = {voice_data}
                                                        getBackListView={this.getBackListView}
                                                    />
                                                </div>
                                                <AgentMainContent
                                                    ref={this.childRef}
                                                    rowData={rowData} 
                                                    onChange={this.handleRowChange}
                                                    onSubmit={this.submitForm} 
                                                    fieldNames={nameLabelMapper}
                                                    modalOpen = {this.handleModal}
                                                    voiceList = {voice_data}
                                                    isLoading = {isAgentLoading}
                                                    knowledgeBase= {knowledgeBase}
                                                    providerName = {providerName}
                                                    allowNewConfig = {this.isAllowNewConfig}
                                                    selectedVoice = {selectedVoice}
                                                    webhooksEnabled={this.state.postWebhooksEnabled}
                                                    resetToAgentDetail={this.resetToAgentDetail}
                                                    showAgentProfileSettings = {showAgentProfileSettings}
                                                    showAgentRoleSettings = {showAgentRoleSettings}
                                                    showAgentActionSettings={showAgentActionSettings}
                                                    showAgentKnowledgeBase = {showAgentKnowledgeBase}
                                                    showAgentDeploy={showAgentDeploy}
                                                    widgetList={widgetList}
                                                    handleDropDownChange={this.handleDropDownChange}
                                                    isCallReady = {isCallReady}
                                                    isCallLoading = {showLoading}
                                                />
                                            </>
                                        }
                                        {isModalOpen && this.getModalContent()}
                                        {isImportModal && this.getImportModel()}
                                        {newAgentModalOpen && this.openCreateAgentModal(rowData)}
                                </Container>
                            }
                        />
                    </Fragment>
                );
            } else {
                return (
                    <Fragment>
                        <Common
                            title="AI Agents"
                            mainLoader = {mainLoader}
                            titleKey={"assistant_allowed"} 
                            titleContent={
                                <>
                                    {
                                        Object.keys(rowData).length > 0 && 
                                        <AgentMainHeader
                                            rowData={rowData}
                                            isMinimized={isMinimized}
                                            onHideSubMenu={this.onHideSubMenu}
                                            fieldNames={nameLabelMapper}
                                            handleDropDownChange={this.handleDropDownChange}
                                            handleAgentOptionChange = {this.handleAgentOptionChange}
                                            isLoading = {mainLoader}
                                            showAgentLoading = {showAgentOptionLoading}
                                            allowDuplicateAgents = {allowDuplicateAgents}
                                            allowDeleteAgents = {allowDeleteAgents}
                                            allowPublishAgents={allowPublishAgents}
                                            onPublish={this.handlePublish}
                                            voiceList = {voice_data}
                                        />
                                    }
                                </>
                            }
                            mainContent={
                                <Container fluid>
                                    {
                                        agentcount > 0 && Object.keys(rowData).length > 0 && 
                                        <AIAgentsSideBar
                                            refreshScreen={this.refreshAgents}
                                            formname={this.formname}
                                            formData={formData}
                                            curRowId={rowData[this.formname+"_id"]}
                                            onAgentChange={this.onAgentChange}
                                            fieldNames={nameLabelMapper}
                                            handleCreateModal = {this.handleCreateAgentModal}
                                            allowNewConfig = {this.isAllowNewConfig}
                                            allowCreateAgents = {allowCreateAgents}
                                            getButtonFromImport={this.getButtonFromImport}
                                            showButtonLoading ={showButtonLoading}
                                            voiceList = {voice_data}
                                        />
                                    }
                                    {isModalOpen && this.getModalContent()}
                                    {isImportModal && this.getImportModel()}
                                    {newAgentModalOpen && this.openCreateAgentModal(rowData)}
                                </Container>
                            }
                        />
                    </Fragment>
                );
            }
        }

        if (isMinimized) {
            return (
                <Fragment>
                    <Common
                        title="AI Agents"
                        isMinimized={isMinimized}
                        mainLoader = {mainLoader}
                        titleKey={"assistant_allowed"}  
                        titleContent={
                            <>
                                {
                                    Object.keys(rowData).length > 0 &&  <AgentMainHeader
                                    rowData={rowData}
                                    isMinimized={isMinimized}
                                    onHideSubMenu={this.onHideSubMenu}
                                    fieldNames={nameLabelMapper}
                                    handleDropDownChange={this.handleDropDownChange}
                                    handleAgentOptionChange = {this.handleAgentOptionChange}
                                    isLoading = {mainLoader}
                                    showAgentLoading = {showAgentOptionLoading}
                                    allowDuplicateAgents = {allowDuplicateAgents}
                                    allowDeleteAgents = {allowDeleteAgents}
                                    allowPublishAgents={allowPublishAgents}
                                    onPublish={this.handlePublish}
                                    voiceList = {voice_data}
                                />
                                }
                            </>
                        }
                        titleBody={<></>}
                        mainContent={
                            <Fragment>
                                {
                                Object.keys(rowData).length > 0 &&
                                <>
                                    <AgentMainContent
                                        ref={this.childRef}
                                        rowData={rowData} 
                                        onChange={this.handleRowChange}
                                        onSubmit={this.submitForm} 
                                        fieldNames={nameLabelMapper}
                                        modalOpen = {this.handleModal}
                                        voiceList = {voice_data}
                                        isLoading = {isAgentLoading}
                                        knowledgeBase= {knowledgeBase}
                                        providerName = {providerName}
                                        allowNewConfig = {this.isAllowNewConfig}
                                        selectedVoice = {selectedVoice}
                                        webhooksEnabled={this.state.postWebhooksEnabled}
                                        resetToAgentDetail={this.resetToAgentDetail}
                                        showAgentProfileSettings = {showAgentProfileSettings}
                                        showAgentRoleSettings = {showAgentRoleSettings}
                                        showAgentActionSettings={showAgentActionSettings}
                                        showAgentKnowledgeBase = {showAgentKnowledgeBase}
                                        showAgentDeploy={showAgentDeploy}
                                        widgetList={widgetList}
                                        handleDropDownChange={this.handleDropDownChange}
                                        isCallReady = {isCallReady}
                                        isCallLoading = {showLoading}
                                    />
                                    {isModalOpen && this.getModalContent()}
                                    {isImportModal && this.getImportModel()}
                                </>
                                }
                            </Fragment>
                        }
                    />
                </Fragment>
            )
        }
        return (
            <Fragment>
                <SplitCommon
                    mobileViewNeedLeftMenu={false}
                    sideBarLoader = {sideBarLoader}
                    mainLoader = {mainLoader}
                    title="AI Agents"
                    sideBarTitleContent={
                        this.getSideBarTitleContent(agentcount)
                    }
                    mainTitleContent={
                        <>
                            {
                                Object.keys(rowData).length > 0 && <AgentMainHeader
                                    rowData={rowData}
                                    isMinimized={isMinimized}
                                    onHideSubMenu={this.onHideSubMenu}
                                    fieldNames={nameLabelMapper}
                                    handleDropDownChange={this.handleDropDownChange}
                                    handleAgentOptionChange = {this.handleAgentOptionChange}
                                    isLoading = {mainLoader}
                                    isCallReady = {isCallReady}
                                    showAgentLoading = {showAgentOptionLoading}
                                    allowDuplicateAgents = {allowDuplicateAgents}
                                    allowDeleteAgents = {allowDeleteAgents}
                                    allowPublishAgents={allowPublishAgents}
                                    onPublish={this.handlePublish}
                                    voiceList = {voice_data}
                                />
                            }
                        </>
                    }
                    sideBarContent={
                        <Container fluid>
                            {
                                agentcount > 0 && Object.keys(rowData).length > 0 && 
                                <AIAgentsSideBar
                                    refreshScreen={this.refreshAgents}
                                    formname={this.formname}
                                    formData={formData}
                                    curRowId={rowData[this.formname+"_id"]}
                                    onAgentChange={this.onAgentChange}
                                    fieldNames={nameLabelMapper}
                                    handleCreateModal = {this.handleCreateAgentModal}
                                    allowNewConfig = {this.isAllowNewConfig}
                                    allowCreateAgents = {allowCreateAgents}
                                    getButtonFromImport={this.getButtonFromImport}
                                    showButtonLoading ={showButtonLoading}
                                    voiceList = {voice_data}
                                />
                            }
                        </Container>
                    }
                    mainContent={
                        <Fragment>
                            {
                                Object.keys(rowData).length > 0 &&
                                <>
                                    <AgentMainContent 
                                        ref={this.childRef}
                                        rowData={rowData} 
                                        onChange={this.handleRowChange}
                                        onSubmit={this.submitForm} 
                                        fieldNames={nameLabelMapper}
                                        modalOpen = {this.handleModal}
                                        voiceList = {voice_data}
                                        isLoading = {isAgentLoading}
                                        knowledgeBase= {knowledgeBase}
                                        providerName = {providerName}
                                        allowNewConfig = {this.isAllowNewConfig}
                                        selectedVoice = {selectedVoice}
                                        webhooksEnabled={this.state.postWebhooksEnabled}
                                        resetToAgentDetail={this.resetToAgentDetail}
                                        showAgentProfileSettings = {showAgentProfileSettings}
                                        showAgentRoleSettings = {showAgentRoleSettings}
                                        showAgentActionSettings={showAgentActionSettings}
                                        showAgentKnowledgeBase = {showAgentKnowledgeBase}
                                        showAgentDeploy={showAgentDeploy}
                                        widgetList={widgetList}
                                        handleDropDownChange={this.handleDropDownChange}
                                        isCallReady = {isCallReady}
                                        isCallLoading = {showLoading} 
                                    />
                                    {isModalOpen && this.getModalContent()}
                                    {newAgentModalOpen &&  this.openCreateAgentModal(rowData)}
                                    {isImportModal && this.getImportModel()}
                                </>
                            }
                                {/* <div className='app-footer-right agent-footer'>
                                    <div id="WebCall"></div>
                                        {isCallReady && (
                                            <Popover
                                                className="rm-max-width"
                                                innerClassName="agent-popover"
                                                placement="bottom-start"
                                                fade={false}
                                                hideArrow
                                                isOpen={popoverOpen}
                                                target="WebCall"
                                                toggle={this.togglePopover}
                                            >
                                                <div className='agent-popover-heading'>
                                                    <span className='agents-call-details'>
                                                        <span className="agent-call-icon"><i class="fi fi-ss-user-headset"></i></span> 
                                                        {this.state.agentname}
                                                    </span>
                                                    <span>{cDur|| "0:00"}</span>
                                                </div>
                                                <div className='agent-popover-footer'>
                                                    <img className="agent-cancel-call" src={call_cancel} alt="Call Cancel" onClick={this.stopCall}/>
                                                </div>
                                            </Popover>
                                        )}
                                        
                                </div> */}
                        </Fragment>
                    }
                    titleKey={"assistant_allowed"}  
                />
        </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Agents);
